<template>
  <DataListStateful
    title="Затаможка"
    resource="customs-entry-registrations"
    store="customsEntryRegistrations"
    :columns="columns"
    :disable-adding="true"
    :filter-options="filter"
  >
    <template v-slot:toolbar>
      <v-flex
        xs2
        class="ml-3"
      >
        <DirectionSelect
          :direction="direction"
          class="ma-1"
          @input="changeDirection"
        />
      </v-flex>
    </template>
  </DataListStateful>
</template>

<script>
import DirectionSelect from "./components/DirectionSelect";
export default {
  components: {
    DirectionSelect,
  },
  data() {
    return {
      columns: [
        {
          title: "Ид",
          name: "id",
          dataPath: "Id",
          isEditLink: true,
          sortable: false,
        },
        { title: "Дата", name: "date", sortable: true },
        {
          title: "Статус",
          name: "state",
          dataPath: "State.Title",
          sortable: true,
        },
        {
          title: "Номер маршрута",
          name: "number",
          width: 55,
          valueFn(item) {
            return item.RoutePrefix
              ? `${item.Number}_${item.RoutePrefix}`
              : `${item.Number}`;
          },
          sortable: true,
          maxLength: 11,
        },
        {
          title: "Направление",
          name: "direction",
          dataPath: "Direction.Title",
          sortable: true,
          maxLength: 20,
        },
        {
          title: "Перевозчик",
          name: "carrier",
          dataPath: "Carrier.Title",
          sortable: true,
        },
        {
          title: "Машина",
          name: "vehicle",
          dataPath: "Vehicle.Title",
          sortable: true,
        },
        {
          title: "Водитель",
          name: "driver",
          dataPath: "Driver.Title",
          sortable: true,
        },
        {
          title: "Дата начала погрузок",
          name: "loadingStartDate",
          width: 80,
          sortable: true,
        },
        {
          title: "Дата последней погрузки",
          name: "loadingLastDate",
          width: 100,
          sortable: true,
        },
        {
          title: "Планируемая дата затаможки",
          name: "customsRegistrationDatePlan",
          type: "date",
          width: 100,
          sortable: true,
        },
        {
          title: "Дата затаможки",
          name: "customsRegistrationDateFact",
          type: "date",
          width: 70,
          sortable: true,
        },
        {
          title: "Плановая дата прибытия на склад",
          name: "arriveToWarehouseDatePlan",
          type: "date",
          width: 120,
          sortable: true,
        },
        {
          title: "Фактическая дата прибытия на склад",
          name: "arriveToWarehouseDateFact",
          type: "date",
          width: 120,
          sortable: true,
        },
        {
          title: "Дата прибытия на место выгрузки",
          name: "arriveToUnloadingPlaceDate",
          width: 120,
          sortable: true,
        },
        {
          title: "Плановая дата прохождения границы",
          name: "passingBorderDatePlan",
          type: "date",
          width: 150,
          sortable: true,
        },
        {
          title: "Кол-во мест",
          name: "cargoPlaces",
          width: 50,
          sortable: true,
        },
        {
          title: "Вес брутто",
          name: "weightBrutto",
          width: 80,
          sortable: true,
          maxLength: 10,
        },
        {
          title: "Объем",
          name: "volume",
          width: 80,
          sortable: true,
          maxLength: 10,
        },
      ],
      filter: {
        date: {
          title: "Дата",
          type: "date",
        },
        routeStates: {
          title: "Статус погрузки",
          type: "enum",
          resource: "route-states",
        },
        route: {
          title: "Номер маршрута",
          type: "reference",
          resource: "routes",
        },
        prefix: {
          title: "Префикс маршрута",
          type: "text",
        },
        direction: {
          title: "Направление",
          type: "reference",
          resource: "countries",
        },
        carrier: {
          title: "Перевозчик",
          type: "reference",
          resource: "carriers",
        },
        vehicle: {
          title: "Машина",
          type: "reference",
          resource: "vehicles",
        },
        driver: {
          title: "Водитель",
          type: "reference",
          resource: "drivers",
        },
        loadingStartDate: {
          title: "Дата начала погрузок",
          type: "date",
        },
        loadingLastDate: {
          title: "Дата последней погрузки",
          type: "date",
        },
        customsRegistrationDatePlan: {
          title: "Планируемая дата затаможки",
          type: "date",
        },
        customsRegistrationDateFact: {
          title: "Дата затаможки",
          type: "date",
        },
        arriveToWarehouseDatePlan: {
          title: "Плановая дата прибытия на склад",
          type: "date",
        },
        arriveToWarehouseDateFact: {
          title: "Фактическая дата прибытия на склад",
          type: "date",
        },
        arriveToUnloadingPlaceDate: {
          title: "Дата прибытия на место выгрузки",
          type: "date",
        },
        passingBorderDatePlan: {
          title: "Плановая дата прохождения границы",
          type: "date",
        },
        cargoPlaces: {
          title: "Кол-во мест",
          type: "int",
        },
        weightBrutto: {
          title: "Вес брутто",
          type: "decimal",
        },
        volume: {
          title: "Объем",
          type: "decimal",
        },
      },
    };
  },
  computed: {
    direction() {
      return this.$store.state.customsEntryRegistrations.filter.direction.value;
    },
  },
  methods: {
    changeDirection(direction) {
      if (direction) {
        this.$store.state.customsEntryRegistrations.filter.direction.value = [
          direction,
        ];
      } else {
        this.$store.state.customsEntryRegistrations.filter.direction.value = null;
      }
    },
  },
};
</script>
